import React, { Component } from 'react';
import TextInfo from '@gerenciatd/next.components.text-info-n';
import CustomLink from '@gerenciatd/next.components.custom-link'
import DeviceCard from './device-card';
import Slider from 'react-slick';
import { SETTINGS } from './utils';

const ELEMENT_COMPONENT_NAME='DeviceCard';
const COMPONENT_NAME = 'tienda-electronica';

const NEXT = 'next';
const BACK = 'back';

const Arrow = ({ way, activeSlide, setActiveSlide }) => {
  let pointer = activeSlide;
  let wayES = 'siguiente';
  if (way === NEXT) {
    pointer = activeSlide + 1;
  } else {
    wayES = 'atrás';
    pointer = activeSlide - 1;
  }

  return (
  <>
    <div className={`arrow ${way}`}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16">
        <path d="m8.105 0 1.41 1.41L3.935 7h12.17v2H3.935l5.59 5.58L8.105 16l-8-8 8-8z" />
      </svg>
      <CustomLink
        onClick={() => { setActiveSlide(activeSlide) }}
        taggingInfo={{
          componentName: `${COMPONENT_NAME}-arrow`,
          componentContent: `ir-${wayES}`,
          componentVariation: 'all',
          componentProduct: '',
        }}
      />
    </div>
    <style jsx>
    {`
      .arrow {
        position: absolute;
        top:42.5%;
        width: 2.25rem;
        height: 2.25rem;
        background-color:white;
        border: 1px solid #aeaeae;
        border-radius: 100%;
        z-index: 1;
        &.next {
          right: 0px;
          transform: rotate(180deg);
        }
        &.prev {
          
          left:0px;
        }
        svg {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%)
        }
      }
    `}
    </style>
  </>
)}



class ShopDevices extends Component {
  constructor(props){
    super(props);
    this.state = {
      activeSlide: 0,
    }
  }

  goNext = () => {
    if (this._slick && this._slick.slickNext) {
      this._slick.slickNext();
    }
  }

  goPrev = () => {
    if (this._slick && this._slick.slickNext) {
      this._slick.slickPrev();
    }
  }

  setActiveSlide = (indexToGo) => {
    if (this._slick && this._slick.slickGoTo) {
      this._slick.slickGoTo(indexToGo);
    }
  };

  
  onBeforeChange = (oldIndex, newIndex) => {
    this.setState({
      activeSlide: newIndex
    })
  }

  appendDots = (dots) => {
    return (
      <ul>
        {dots.map((element, index) => {
          const { className, children } = element.props;
          const { onClick } = children.props;
          return (
            <div className={`dot ${className}`} onClick={onClick}>
              <CustomLink 
                onClick={() => {}}
                taggingInfo={{
                  componentName: COMPONENT_NAME,
                  componentVariation: 'all',
                  componentProduct: '',
                  componentContent: `Ir a ${index}`,
                  componentPerso: '',
                }}
              />
            </div>
          )
        })}
        <style jsx>
          {`
            :global(.slick-dots){
              position: relative;
              display:flex;
              padding:1rem;
              justify-content: center;
            }
            .dot {
              position: relative;
              width: 12px;
              height: 12px;
              border: 1px solid #019df4;
              border-radius: 10px;
              transition: all .3s;
              background-color: transparent;
              margin: 2.5px;
              cursor: pointer;
              outline: 0;
              &.slick-active {
                width: 20px;
                background-color: var(--color-gp--blue);
              }
            }
          
          `}
          </style>
      </ul>
    )};

  render(){
    const deviceCards = [];
    const keys = Object.keys(this.props);
    keys.forEach(key => {
      if (key.indexOf(ELEMENT_COMPONENT_NAME) !== -1) {
        deviceCards.push(key);
      }
    });
    const { activeSlide, custoObjectInfo } = this.props;

    const slickOptions = {
      ...SETTINGS({ slidesToShow: 3 }),
      prevArrow: <Arrow way="next" activeSlide={activeSlide} setActiveSlide={this.goNext} />,
      nextArrow: <Arrow way="prev" activeSlide={activeSlide} setActiveSlide={this.goPrev} />,
    }
    //Making posible editable
    let textInfoCustoObjectInfo1 = null;
    let textInfoCustoObjectInfo2 = null;
    let textInfoCustoObjectInfo3 = null;
    if (custoObjectInfo){
      textInfoCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
        custoObjectInfo,
        entryPoint: 'TextInfo-1',
      })
      textInfoCustoObjectInfo2 = custoObjectInfo.addEntryPoint({
        custoObjectInfo,
        entryPoint: 'TextInfo-2',
      })
      textInfoCustoObjectInfo3 = custoObjectInfo.addEntryPoint({
        custoObjectInfo,
        entryPoint: 'TextInfo-3',
      })
    }

    return (
      <>
        <div className="ShopDevices">
          <div className="container">
            <div className="row">
              <div className="main-info col-xs-12 col-sm-3">
                {this.props['TextInfo-1'] && (<TextInfo {...this.props['TextInfo-1']} custoObjectInfo={textInfoCustoObjectInfo1} />)}
                {this.props['TextInfo-2'] && (<TextInfo {...this.props['TextInfo-2']} custoObjectInfo={textInfoCustoObjectInfo2} />)}
                {this.props['TextInfo-3'] && (<TextInfo {...this.props['TextInfo-3']} custoObjectInfo={textInfoCustoObjectInfo3} />)}
              </div>
              <div className="col-xs-12 col-sm-9">
                <Slider
                  { ...slickOptions}
                  ref={function (c) { this._slick = c; }.bind(this)}
                  appendDots={this.appendDots}
                  beforeChange={this.onBeforeChange}
                >
                  {deviceCards.map((key) => {
                    let currentCustoObjectInfo = null;
                    if (custoObjectInfo) {
                      currentCustoObjectInfo = custoObjectInfo.addEntryPoint({
                        custoObjectInfo,
                        entryPoint: key,
                      })
                    }
                    return (
                      <DeviceCard key={key} {...this.props[key]} custoObjectInfo={currentCustoObjectInfo} />
                    )
                  })}
                </Slider>
              </div>
            </div>
          </div>
        </div>
        <style jsx>
          {`
            .ShopDevices{
              padding: 3rem 0;
              background-color:#f5f5f5;
              .container {
                .row {
                  .main-info {
                    text-align: left;
                  }
                  .slick-slider.ShopDevicesSlider{
                    background-color: red;
                    
                    position: relative;
                    :global(.slick-dots){
                      position: absolute;
                    }
                  }
                }
              }
            }

            @media screen and (max-width: 500px){
              .ShopDevices {
                padding: 1rem 0px;
                .container {
                  .row {
                    .main-info {
                      padding-bottom: 2rem;
                    }
                  }
                }
              }
            }
          
          `}
        </style>
      </>
    )

  }
}

export default ShopDevices;